import React from "react";

function Footer() {

    return (
        
                <footer class="page-footer font-small cyan darken-3">

                <div class="container">

                    <div class="row">

                        <div class="col-md-6 text-left py-5">© 2020 Copyright:
                            <a href=""> Simba.com</a>
                        </div>

                        <div class="col-md-6 text-right py-5">
                            <div class="mb-2 flex-center">
                            <a class="fb-ic">
                                <i class="fab fa-facebook-f fa-lg white-text mr-md-5 mr-3 fa-2x"> </i>
                            </a>
                            <a class="tw-ic">
                                <i class="fab fa-twitter fa-lg white-text mr-md-5 mr-3 fa-2x"> </i>
                            </a>
                            <a class="gplus-ic">
                                <i class="fab fa-google-plus-g fa-lg white-text mr-md-5 mr-3 fa-2x"> </i>
                            </a>
                            <a class="li-ic">
                                <i class="fab fa-linkedin-in fa-lg white-text mr-md-5 mr-3 fa-2x"> </i>
                            </a>

                            <a class="ins-ic">
                                <i class="fab fa-instagram fa-lg white-text mr-md-5 mr-3 fa-2x"> </i>
                            </a>

                            </div>
                        </div>

                    </div>

                </div>

                </footer>

        

    );
}

export default Footer;